export default __webpack_public_path__ + "static/media/slider_1.2afa1782.jpg";